import * as React from "react";
import { CommonHelper } from "../../../../../../../../react-core/Helpers/CommonHelper";
import { Lightbox, LightboxType } from "../../../../../../../../react-core/Html/Components/Lightbox";
import { SelectEditor } from "../../../../../../../../react-core/Html/SelectEditor";
import { Guid } from "../../../../../../../../react-core/Utils/Guid";
import { UserClaim } from "../../../../../../../../Wrap/Constants/Enums/UserClaim";
import { checkPermission } from "../../../../../../../Shared/Permission/PermissionHelper";
import { PortfolioDashboardStore } from "../../../Store/Variable";

interface IFileUploaderProps {
    clAccountId: string;
    isPopUp: boolean;
    onClose: (val: boolean) => void;
}

interface IFileUploaderState {
    selectedHeadClAccountId: string;
    headClAccountIds: string[];
}

export class FileUploader extends React.Component<IFileUploaderProps, IFileUploaderState> {
    constructor(props: IFileUploaderProps) {
        super(props);
        this.state = {
            selectedHeadClAccountId: "",
            headClAccountIds: [],
        };
    }
    componentDidMount() {
        if (CommonHelper.isNullOrEmpty(this.props.clAccountId)) {
            const allAccounts = PortfolioDashboardStore.getData();
            const headClAccountIds = allAccounts.map((a) => a.HeadClAccountId);
            this.setState({ headClAccountIds: headClAccountIds, selectedHeadClAccountId: headClAccountIds[0] });
        } else {
            this.setState({
                headClAccountIds: [this.props.clAccountId],
                selectedHeadClAccountId: this.props.clAccountId,
            });
        }
    }
    public render(): JSX.Element {
        const { isPopUp, onClose } = this.props;

        return (
            <div>
                <Lightbox
                    show={isPopUp}
                    title={"Document upload"}
                    contentAfterTitle={null}
                    onClose={() => onClose(false)}
                    type={LightboxType.Modal}
                    unclosable={false}
                    noOverlay={false}
                    noAutofocus={false}
                    cssWrapper={"wider is-default-lightbox is-wide"}
                >
                    {CommonHelper.isNullOrEmpty(this.props.clAccountId) && (
                        <SelectEditor
                            key={Guid.getNext()}
                            label={"Head Account"}
                            options={this.state.headClAccountIds}
                            getText={(key) => key}
                            selected={
                                this.state.selectedHeadClAccountId
                                    ? this.state.selectedHeadClAccountId
                                    : this.state.headClAccountIds[0]
                            }
                            cssWrapper="control-size-200 mb-0"
                            onChange={(v) => {
                                this.setState({ selectedHeadClAccountId: v });
                            }}
                        />
                    )}
                    <div style={{ position: "relative", minHeight: "280px" }}>
                        {!CommonHelper.isNullOrEmpty(this.state.selectedHeadClAccountId) &&
                            checkPermission(UserClaim.AdviserPortalDluDocumentLibraryAddDocumentCanView) && (
                                <iframe
                                    src={`/clients/documents/documentlibrary-adddocument.aspx?claccountid=${this.state.selectedHeadClAccountId}`}
                                    frameBorder="0"
                                    scrolling="yes"
                                    style={{
                                        height: "100%",
                                        width: "100%",
                                        position: "absolute",
                                        right: 0,
                                        bottom: 0,
                                        left: 0,
                                    }}
                                ></iframe>
                            )}
                    </div>
                </Lightbox>
            </div>
        );
    }
}
